import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getThousandComma } from "../../ApiTS/ApiCommonTS";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import Flex from "../../components/DefaultStyles/Flex";
import LineBox from "../../components/DefaultStyles/LineBox";
import Loader from "../../components/DefaultStyles/Loader";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import UplusMatchingInfoFilter from "../../components/pages/Party/UplusMatchingInfo/UplusMatchingInfoFilter";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { TotalCount } from "../Users/UserInfo";
import LineBtn from "../../components/Button/LineBtn";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { authType } from "../Login";
import UplusCodeLogModal from "../../components/pages/Party/UplusMatchingInfo/UplusCodeLogModal";

export interface IUplus {
  enddate?: string;
  id: string;
  code: string;
  name: string;
  phone: string;
  birth: string;
  uplus_status: number;
  uid: number;
  partyid: number;
  role: number;
  admin: string;
  insertdate: string;
  updatedate: string;
  state: string;
}

export const uplusInfoFilterState = atom({
  key: "uplusInfoFilterState",
  default: {
    searchType: "",
    searchValue: "",
    stateValue: "",
    dateType: "",
    startdate: "",
    enddate: "",
    page: 0,
  },
});

export default function UplusMatchingInfo() {
  const navigate = useNavigate();
  const auth = useRecoilValue(authType);

  const [filter, setFilter] = useRecoilState(uplusInfoFilterState);
  const [page, setPage] = useState(filter?.page ?? 0);

  useEffect(() => {
    setFilter((prev) => ({ ...prev, page: 0 }));
  }, []);

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: auth?.uplus
      ? `uplus2?page=${page}&size=10` +
        (filter?.searchValue !== ""
          ? `&${filter?.searchType}=${filter?.searchValue}`
          : ``) +
        (filter?.stateValue !== "" ? `&state=${filter?.stateValue}` : ``) +
        (filter?.enddate !== "" && !filter?.enddate?.includes("선택")
          ? `&datetype=${filter?.dateType}&startdate=${
              filter?.startdate
            }&enddate=${dayjs(filter?.enddate)
              ?.add(1, "day")
              ?.format("YYYY-MM-DD")}`
          : ``)
      : undefined,
  });
  const [viewLog, setViewLog] = useState({
    modal: false,
    code: "",
  });

  const tableHead = [
    "Index",
    "로그 확인",
    "결합 코드",
    "휴대폰 번호",
    "이름",
    "생년월일",
    "결합 상태",
    "UID",
    "PID",
    "ROLE",
    "파티 상태",
    "최초 등록일",
    "최종 수정일",
    "관리자",
  ];

  const excelHead = tableHead?.filter(
    (a) =>
      a !== "" &&
      a !== "선택" &&
      a !== "ID" &&
      a !== "로그 확인" &&
      a !== "신청자" &&
      a !== "최종 업데이트"
  );

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "유플러스 결합 정보를 가져오는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      {/* <PageTitle title="유플러스 결합" /> */}

      <UplusMatchingInfoFilter
        pageResetEvent={() => {
          setPage(0);
        }}
        fetchData={() =>
          fetchData({
            method: "get",
            url:
              `uplus2?page=${page}&size=10` +
              (filter?.searchValue !== ""
                ? `&${filter?.searchType}=${filter?.searchValue}`
                : ``) +
              (filter?.stateValue !== ""
                ? `&state=${filter?.stateValue}`
                : ``) +
              (filter?.enddate !== "" && !filter?.enddate?.includes("선택")
                ? `&datetype=${filter?.dateType}&startdate=${
                    filter?.startdate
                  }&enddate=${dayjs(filter?.enddate)
                    ?.add(1, "day")
                    ?.format("YYYY-MM-DD")}`
                : ``),
          })
        }
      />

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={1120}>
          <>
            {response?.data?.items?.map((d: IUplus) => {
              return (
                <TableBody key={d?.id}>
                  <TableBodyItem>{d?.id}</TableBodyItem>

                  <TableBodyItem>
                    <LineBtn
                      btnText="보기"
                      btnClickEvent={() =>
                        setViewLog({
                          modal: true,
                          code: d?.code ?? "",
                        })
                      }
                    />
                  </TableBodyItem>
                  <TableBodyItem>{d?.code}</TableBodyItem>
                  <TableBodyItem isKeepAll={true}>{d?.phone}</TableBodyItem>
                  <TableBodyItem>{d?.name}</TableBodyItem>
                  <TableBodyItem isKeepAll={true}>{d?.birth}</TableBodyItem>
                  <TableBodyItem>
                    {d?.uplus_status === 1
                      ? "Y"
                      : d?.uplus_status === 0
                      ? "N"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    isKeepAll={true}
                    clickable={d?.uid > 0 ? true : false}
                    onClick={() => {
                            if (d?.uid > 0) {
                              setFilter((prev) => ({ ...prev, page }));
                              navigate(`/users/info/${d?.uid ?? 0}`);
                            }
                    }}
                  >
                    {d?.uid ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    isKeepAll={true}
                    clickable={d?.partyid ? true : false}
                    onClick={() => {
                            if (d?.partyid > 0) {
                        setFilter((prev) => ({ ...prev, page }));
                        navigate(`/party/info/${d?.partyid ?? 0}`);
                      }
                    }}
                  >
                    {d?.partyid ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.role === 0 || d?.role === 1 || d?.role === 2
                      ? d?.role === 0
                        ? "파티장"
                        : d?.role === 1
                        ? "파티원"
                        : "위임 파티장"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.state ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.insertdate
                      ? dayjs(d?.insertdate ?? undefined)?.format("YYYY-MM-DD")
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {dayjs(d?.updatedate ?? undefined)?.format(
                      "YYYY-MM-DD HH:mm"
                    )}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.admin?.length > 0 ? d?.admin : "-"}
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response?.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <SpaceBetween>
        <div />

        <Flex gapSize={10}>
          <ExcelDownload
            tableHead={excelHead}
            pushedData={(e: IUplus) => {
              return [
                e.id,
                e.code,
                e?.phone,
                e?.name,
                e?.birth,
                e?.uplus_status === 1 ? "Y" : e?.uplus_status === 0 ? "N" : "-",
                e?.uid ?? "-",
                e?.partyid ?? "-",
                e?.role
                  ? e?.role === 0
                    ? "파티장"
                    : e?.role === 1
                    ? "파티원"
                    : "위임 파티장"
                  : "-",
                e?.insertdate
                  ? dayjs(e?.insertdate ?? undefined)?.format("YYYY-MM-DD")
                  : "-",
                dayjs(e?.updatedate ?? undefined)?.format("YYYY-MM-DD HH:mm"),
              ];
            }}
            dataUrl={
              `uplus2?page=0&size=1000` +
              (filter?.searchValue !== ""
                ? `&${filter?.searchType}=${filter?.searchValue}`
                : ``) +
              (filter?.stateValue !== ""
                ? `&state=${filter?.stateValue}`
                : ``) +
              (filter?.enddate !== "" && !filter?.enddate?.includes("선택")
                ? `&datetype=${filter?.dateType}&startdate=${
                    filter?.startdate
                  }&enddate=${dayjs(filter?.enddate)
                    ?.add(1, "day")
                    ?.format("YYYY-MM-DD")}`
                : ``)
            }
            disabled={
              response?.data?.items?.length < 1 || !response?.data?.items
            }
            title="유플러스 결합"
          />
        </Flex>
      </SpaceBetween>

      {viewLog?.modal && (
        <UplusCodeLogModal
          closeEvent={() =>
            setViewLog({
              modal: false,
              code: "",
            })
          }
          code={viewLog?.code}
        />
      )}

      {loading && <Loader />}
    </>
  );
}
